import { render, staticRenderFns } from "./VisitPaymentModal.vue?vue&type=template&id=9d8984b0&scoped=true"
import script from "./VisitPaymentModal.vue?vue&type=script&lang=js"
export * from "./VisitPaymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8984b0",
  null
  
)

export default component.exports